import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "make-secure",
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      secureValue: types.secure.getters.GET_SECURE
    })
  },
  mounted() {},
  methods: {}
};
